import { useSelector } from 'react-redux';
import type { RootState } from 'reducers/types';

function useUser() {
  const {
    firstName = '',
    lastName = '',
    ...rest
  } = useSelector((state: RootState) => state.entities.user);
  const fullName = [firstName, lastName].filter(Boolean).join(' ');

  return {
    firstName,
    lastName,
    fullName,
    ...rest,
  };
}

export { useUser };
